export default "__VITE_ASSET__DlaBBXgl__"